<template>
    <div v-wechat-title="title" class="padding10">
        <!-- <CloseButton type="close" msg="closeWindow" :title="title"></CloseButton> -->
        <div class="align-left">
            <span class="line-height40 align-left">当前使用毒麻药箱:</span>
            <item-input style="width: 200px" type="select" :options="narcotics_boxs" :readonly="had_used" v-model="using_box_id"></item-input>
            <el-button type="primary" size="mini" v-if="had_used" @click="closeBox">不使用</el-button>
            <el-button type="primary" size="mini" v-else @click="openBox">使用</el-button>
        </div>
        <template v-if="usage_boxs_length > 0">
            <div v-for="(g, key) in usage_boxs" :key="key">
                <crud-facecade
                    :rowChangesMonitor="false"
                    :columns="columnList"
                    :url="getUrl(key)"
                    :addButton="{ enabled: false }"
                    :updateButton="{ enabled: false }"
                    :fuzzySearch="false"
                    @print="print"
                >
                    <template slot="filter">
                        <el-col :span="3" class="align-left padding-right20">
                            <h3 class="align-left">{{ g[0].box_name }}</h3>
                        </el-col>
                    </template>
                </crud-facecade>
            </div>
        </template>
        <div v-else>暂无毒麻药使用记录</div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `AnesNarcoticsBox`,
    props: {

    },
    data() {
        return {
            title: `毒麻药箱`,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            using_box_id: undefined,
            had_used: false,
            narcotics_boxs: [],
            usage_boxs: {},
            usage_boxs_length: 0,
            list2: []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
        this.loadBox()
        this.loadDrugsUsage()
    },
    computed: {
        ...mapGetters([`currentUser`, `sys_enums`]),
        columnList() {
            return [{
                type: `string`,
                label: `id`,
                prop: `id`,
                isKey: true
            }, {
                type: `string`,
                label: `药品名称`,
                prop: `name`,
                isListable: true
            }, {
                type: `string`,
                label: `批号`,
                width: `160`,
                prop: `batch_number`,
                isListable: true
            }, {
                type: `string`,
                label: `规格`,
                width: `200`,
                prop: `spec`,
                isListable: true
            }, {
                type: `float`,
                label: `用量`,
                width: `120`,
                prop: `use_dose`,
                readonly: true,
                isListable: true
            }, {
                type: `number`,
                label: `使用支数`,
                width: `120`,
                prop: `use_amount`,
                readonly: false,
                isListable: true,
                blur: (that, { row, index }) => { // added by xiaorui,ACIS-23432 毒麻药箱用量计算 使用支数=术中用量/药品默认剂量，向上取整
                    let oldrow = _.find(this.list2, { id: row.id })
                    let oldAmount = oldrow.use_amount
                    let newAmount = row.use_amount
                    let newusedose = newAmount * row.dose
                    if (newusedose < row.use_dose) {
                        this.$alert(`<strong>使用支数不能小于实际支数，规则：使用支数=用量/药品默认剂量</strong>`, `失败`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                        this.$set(row, `use_amount`, oldAmount)
                        return false
                    }
                    let totalamount = row.remain_amount
                    let cAmount = newAmount - oldAmount
                    // added by xiaorui,2022-04-02，ACIS-23432 毒麻药箱用量计算 超过剩余量弹提示
                    if (totalamount < cAmount) {
                        this.$alert(`<strong>药箱共剩余${totalamount}支药品,使用支数已经超过领用支数</strong>`, `失败`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                        this.$set(row, `use_amount`, oldAmount)
                        return false
                    } else {
                        let destruction = (newAmount * (row.dose || 1) - row.use_dose) // 支数 * 默认剂量-使用量=销毁量
                        row.destruction_dose = destruction
                        this.$set(row, `destruction_dose`, destruction)
                    }
                    this.saveUseDrugData(row)
                    console.log(row)
                }
            }, {
                type: `float`,
                label: `销毁量`,
                width: `120`,
                prop: `destruction_dose`,
                readonly: true,
                isListable: true
            }, {
                type: `buttongroup`,
                label: `处方`,
                prop: `oper`,
                width: `80`,
                isListable: true,
                readonly: false,
                options: [{
                    class: `is-plain is-circle`,
                    label: ``,
                    icon: `el-icon-document`,
                    type: `primary`,
                    emit: `print`,
                    permission: `default`
                }]
            }]
        }
    },
    methods: {
        loadBox() {
            let req = this.myaxios.get(`/api/Intraoperative/NarcoticsBoxTrace/Traces?surgeryId=${this.surgeryId}`)
            req.then(data => {
                let r = _.filter(data, d => { return !d.biz_surgery_info_id && d.enum_narcotics_box_trace_status == 2 })
                let using = _.find(data, { biz_surgery_info_id: this.surgeryId * 1 })
                if (using) {
                    r.push(using)
                    this.using_box_id = using.sys_narcotics_box_id
                    this.had_used = true
                }
                this.narcotics_boxs = r.map(d => {
                    return {
                        value: d.sys_narcotics_box_id,
                        label: `${d.sys_narcotics_box_name} `,
                        jianpin: d.box.abbr,
                        code: ` ${d.dic_operating_room_name || `--`}  ${d.receiver}`
                    }
                })
            }).catch(e => { console.log(e) })
        },
        loadDrugsUsage(resolve, key) {
            let req = this.myaxios.get(`/api/Intraoperative/NarcoticsBoxTrace/DrugUsageBySurgeryInfo?surgeryInfoId=${this.surgeryId}`)
            req.then(data => {
                let r = _.map(data, d => {
                    let amount = d.use_amount || Math.ceil(d.use_dose / (d.prepare_drug.drug.dose || 1)) // added by xiaorui，ACIS-23432，{使用}支数}={术中用量}/{药品默认剂量}，向上取整
                    return {
                        biz_narcotics_box_trace_id: d.prepare_drug.biz_narcotics_box_trace_id,
                        box_name: d.prepare_drug.trace.sys_narcotics_box_name,
                        name: d.prepare_drug.drug.name,
                        spec: d.prepare_drug.drug.spec,
                        use_dose: d.use_dose,
                        use_amount: amount,
                        destruction_dose: d.destruction_dose || (amount * (d.prepare_drug.drug.dose || 1) - d.use_dose),
                        batch_number: d.prepare_drug.batch_number,
                        id: d.id,
                        dic_drug_id: d.prepare_drug.dic_drug_id,
                        prepare_drug_amount: d.prepare_drug.amount,
                        remain_amount: d.prepare_drug.remain_amount,
                        dose: d.prepare_drug.drug.dose || 1
                    }
                })
                this.usage_boxs_length = r && r.length || 0
                this.usage_boxs = _.groupBy(r, `biz_narcotics_box_trace_id`)
                this.list2 = r
                if (resolve) {
                    resolve(this.usage_boxs[key])
                }
            }).catch(e => console.log(e))
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: {},
                    action: `ok`
                }
                winformMsg.acceptMessage(cefJson)
            }
        },
        openBox() {
            let req = this.myaxios.put(`/api/Intraoperative/NarcoticsBoxTrace/OpenBox?surgeryInfoId=${this.surgeryId}&boxId=${this.using_box_id}`)
            req.then(data => {
                this.had_used = true
                this.sendMessage()
            }).catch(e => console.log(e))
        },
        closeBox() {
            let req = this.myaxios.put(`/api/Intraoperative/NarcoticsBoxTrace/CloseBox?surgeryInfoId=${this.surgeryId}`)
            req.then(data => {
                this.had_used = false
                this.sendMessage()
            }).catch(e => console.log(e))
        },
        getUrl(key) {
            return {
                get: () => {
                    // return Promise.resolve(this.usage_boxs[key])
                    return new Promise(resolve => {
                        this.loadDrugsUsage(resolve, key)
                        // resolve(this.usage_boxs)
                    })
                },
                putMany: (rows) => {
                    return new Promise(resolve => {
                        let reqs = rows.map(d => {
                            let oldrow = _.find(this.list2, { id: d.id })
                            let newrow = Object.assign({}, oldrow, d)

                            let destruction = (newrow.use_amount * (newrow.dose || 1) - newrow.use_dose)
                            newrow.destruction_dose = destruction
                            console.log(newrow)
                            return this.myaxios.put(`/api/Intraoperative/NarcoticsBoxTrace/PutUseDrug`, newrow)
                        })

                        this.myaxios.all(...reqs).then(() => {
                            resolve(this.usage_boxs)
                        // this.loadDrugsUsage()
                        }).catch(e => console.log(e))
                    })
                }
            }
        },
        print({ row }) {
            this.$store.dispatch(`PRINT_PDF`, { host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.CFD021,
                    id1: this.surgeryId,
                    objId: row.id
                } })
        },
        saveUseDrugData(row) {
            return new Promise(resolve => {
                return this.myaxios.put(`/api/Intraoperative/NarcoticsBoxTrace/PutUseDrug`, row).then(() => {
                    resolve(this.usage_boxs)
                }).catch(e => console.log(e))
            })
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/NarcoticsBox.vue